import { TextField as RadixTextField } from '@radix-ui/themes'
import { forwardRef } from 'react'
import type { ComponentPropsWithoutRef } from 'react'

type TextFieldProps = ComponentPropsWithoutRef<typeof RadixTextField.Root>

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ size = '2', variant = 'surface', ...props }, ref) => {
    return (
      <RadixTextField.Root ref={ref} size={size} variant={variant} {...props} />
    )
  }
)

TextField.displayName = 'TextField'
